export function formatPhoneNumber(value) {
  if (!value) return value;

  value = String(value);

  const lastIsDash = value.slice(-1) === "-";

  const phoneNumber = value.replace(/[^\d]/g, "");
  const startsWith1 = phoneNumber[0] === "1";

  const phoneNumberLength = phoneNumber.length;

  // Don't change formatting for numbers that are too short
  if (phoneNumberLength < 4) return `${phoneNumber}${lastIsDash ? "-" : ""}`;

  // Format phone numbers that start with 1
  if (startsWith1) {
    if (phoneNumberLength === 4) {
      return `1-${phoneNumber.slice(1, 4)}${lastIsDash ? "-" : ""}`;
    }

    if (phoneNumberLength < 8) {
      return `1-${phoneNumber.slice(1, 4)}-${phoneNumber.slice(4)}`;
    }

    return `1-${phoneNumber.slice(1, 4)}-${phoneNumber.slice(
      4,
      7
    )}-${phoneNumber.slice(7, 11)}`;
  }

  // Format phone numbers that don't start with 1
  if (phoneNumberLength < 7) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}${
      lastIsDash ? "-" : ""
    }`;
  }
  return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`;
}

// Needed because we only want to send the number without the country code when logging in or sending text code
// Currectly only handles US and Canadian numbers that use "1" as the country code
export function phoneNumberWithoutCountryCode(phoneNumber) {
  const startsWith1 = phoneNumber[0] === "1";

  if (startsWith1) {
    return phoneNumber.slice(2);
  }
  return phoneNumber;
}

// Used when you want to use both these functions to format the number and remove the country code
export function formatPhoneNumberWithoutCountryCode(phoneNumber) {
  if (!phoneNumber) return phoneNumber;
  return phoneNumberWithoutCountryCode(formatPhoneNumber(phoneNumber));
}

export function removeFormatPhoneNumber(phoneNumber) {
  const unformatted = phoneNumber.replace(/[^0-9]/g, "");
  // Add the plus if there is a country code
  const plusSign = unformatted.length > 10 ? "+" : "";
  return `${plusSign}${unformatted}`;
}
